import React from 'react';
import { useParams } from 'react-router-dom';

import { OfferConfigurePageContainer } from '@occc-app/offerHelpers/components/OfferConfigurePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';
import { useChainId } from '@occc-app/Chain/hooks';
import { getCreatePageLinks, useGetCampaignName } from '@occc-app/routes/CampaignComponents/utils';

import { messages } from '../messages';
import { PunchcardConfigureFormContainer } from '../components/PunchcardConfigureForm/PunchcardConfigureFormContainer';

export const PunchcardConfigurePageContainer: React.FC = () => {
  const { id: campaignId = '', punchcardId = '' } = useParams<{
    id: string;
    punchcardId: string;
  }>();
  const chainId = useChainId();
  const campaignName = useGetCampaignName(chainId, campaignId);

  return (
    <OfferConfigurePageContainer
      campaignId={campaignId}
      offerId={punchcardId}
      getBreadcrumbLinks={(offerName) => getCreatePageLinks(campaignId, campaignName, offerName)}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.ClubOrPunchcard}
      ConfigureFormContainer={PunchcardConfigureFormContainer}
    />
  );
};
